import React from "react";

/**
 * Two diagonal bands running against each other. The track is duplicated
 * exactly once and translated by -50%, which is the only way to get a marquee
 * that loops with no seam and no JavaScript.
 */
export default function Ticker({ items, dir = 1, tilt = -2.4 }) {
  const run = [...items, ...items, ...items, ...items];

  return (
    <div className="ticker" style={{ "--tilt": `${tilt}deg` }} aria-hidden="true">
      <div className="ticker__track" data-dir={dir === 1 ? "fwd" : "rev"}>
        {[0, 1].map((copy) => (
          <div className="ticker__set" key={copy}>
            {run.map((item, i) => (
              <span className="ticker__item" key={`${copy}-${i}`}>
                <span className="display">{item}</span>
                <em />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
